import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete, TextField } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { ref, update } from 'firebase/database';
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';

import { database } from '../../../Common/Firebase';
import { throwErrorRollbar } from '../../../index';

import '../../../Components/ModalMaterial/style.scss';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const StudentGroupModal = ({ open, setOpen, student, editStudent, studetnItems, feachGroupListData }) => {
  const { t } = useTranslation();
  const [groupName, setGroupName] = useState('');
  const [groupNameDirty, setGroupNameDirty] = useState(false);
  const [groupNameError, setGroupNameError] = useState('');
  const [isFormValid, setIsFormValid] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [isFocused, setIsFocused] = useState(false);

  const autocompleteRef = useRef(null);

  const groupNameHandler = e => {
    const value = e.target.value;
    setGroupNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setGroupNameError(t(''));
    } else if (!/^[A-Za-zА-Яа-яҐґЄєІіЇї0-9\s/'/-]*$/.test(value.trim())) {
      setGroupNameError(t('The name must consist of letters and numbers'));
    } else {
      setGroupNameError('');
    }
  };

  const blurHandler = e => {
    const value = e.target.value;
    setGroupNameDirty(true);

    if (value === undefined || value.trim() === '') {
      setGroupNameError(t('field is required'));
    } else {
      setGroupNameError('');
    }
  };

  useEffect(() => {
    if ((groupNameError && !editStudent) || groupName.trim() === '' || selectedStudents.length === 0) {
      setIsFormValid(false);
    } else {
      setIsFormValid(true);
    }
  }, [groupName, groupNameError, selectedStudents, editStudent]);

  const onSubmitFunc = async () => {
    const id = uuidv4();
    const selectedStudentData = selectedStudents.map(student => ({
      FIO: student.FIO,
      email: student.email.replace(/\./g, ''),
    }));
    const emailsArr = selectedStudentData.map(item => item.email);

    emailsArr.map(async email => {
      try {
        await update(ref(database, `Students/${email}`), {
          active: true,
        });
      } catch (error) {
        console.log(error);
        throwErrorRollbar(error);
      }
    });

    try {
      await update(ref(database, `StudentsGroup/${id}`), {
        id: id,
        groupName: groupName,
        active: true,
        students: selectedStudentData,
        subjects: {
          english: {
            activeSub: false,
            name: 'english',
            getNotebook: false,
          },
          geography: {
            activeSub: false,
            name: 'geography',
            getNotebook: false,
          },
          geometry: {
            activeSub: false,
            name: 'geometry',
            getNotebook: false,
          },
          historyUkraine: {
            activeSub: false,
            name: 'historyUkraine',
            getNotebook: false,
          },
          ukrainianLanguage: {
            activeSub: false,
            name: 'ukrainianLanguage',
            getNotebook: false,
          },
          physics: {
            activeSub: false,
            name: 'physics',
            getNotebook: false,
          },
          biology: {
            activeSub: false,
            name: 'biology',
            getNotebook: false,
          },
          mathematics: {
            activeSub: false,
            name: 'mathematics',
            getNotebook: false,
          },
          nature: {
            activeSub: false,
            name: 'nature',
            getNotebook: false,
          },
          algebra: {
            activeSub: false,
            name: 'algebra',
            getNotebook: false,
          },
          youngSchoolMathematics: {
            activeSub: false,
            name: 'youngSchoolMathematics',
            getNotebook: false,
          },
          allWorldHistory: {
            activeSub: false,
            name: 'allWorldHistory',
            getNotebook: false,
          },
          chemistry: {
            activeSub: false,
            name: 'chemistry',
            getNotebook: false,
          },
          youngSchoolRussianLanguage: {
            activeSub: false,
            name: 'youngSchoolRussianLanguage',
            getNotebook: false,
          },
          ukrainianLiterature: {
            activeSub: false,
            name: 'ukrainianLiterature',
            getNotebook: false,
          },
          foreignLiterature: {
            activeSub: false,
            name: 'foreignLiterature',
            getNotebook: false,
          },
          youngUkrainianLanguage: {
            activeSub: false,
            name: 'youngUkrainianLanguage',
            getNotebook: false,
          },
          german: {
            activeSub: false,
            name: 'german',
            getNotebook: false,
          },
          kvol: {
            activeSub: false,
            name: 'kvol',
            getNotebook: false,
          },
        },
      });

      setOpen(false);
      feachGroupListData();
    } catch (error) {
      console.log(error);
      throwErrorRollbar(error);
    }
  };

  return (
    <div
      className={open ? 'modal-form modal-form--open' : 'modal-form'}
      onClick={e => {
        if (!isFocused) {
          setOpen(false);
        }
        e.stopPropagation();
      }}
    >
      <div
        className="modal-form-content"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <form>
          <div className="modal-header">
            <h2>{t('Create a group of students')}:</h2>
            <button
              className="btn btn-icon"
              onClick={e => {
                setOpen(false);
                e.preventDefault();
              }}
            >
              <span className="icon icon-plus"></span>
            </button>
          </div>

          <div className="modal-body" id="modal-body">
            <div className="form-control autocomplete-control">
              <Autocomplete
                id="groupName"
                options={[]}
                value={student ? student.groupName : ''}
                onInputChange={(e, v) => setGroupName(v)}
                onBlur={blurHandler}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('groupName')}
                    value={student.groupName}
                    onChange={groupNameHandler}
                    name="groupName"
                    placeholder=" "
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                )}
              />
              {groupNameDirty && groupNameError && <span className="error">{groupNameError}</span>}
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                multiple
                id="students-arr"
                options={studetnItems}
                disableCloseOnSelect
                getOptionLabel={option => option.FIO}
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} />
                    {option.FIO}
                  </li>
                )}
                value={selectedStudents}
                onChange={(event, newValue) => setSelectedStudents(newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('select students')}
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                )}
              />
            </div>
          </div>

          <div className="modal-footer">
            <button
              className="btn btn-primary more btn-active"
              onClick={e => {
                onSubmitFunc();
                e.preventDefault();
              }}
              disabled={!isFormValid}
            >
              {t('create')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default StudentGroupModal;
